<template>
  <v-card flat>
    <v-card-title>Informações básicas</v-card-title>
    <v-divider />
    <v-card-text>
      <v-form
        ref="formRef"
        v-model="formValid"
        @update:model-value="emitValidity"
      >
        <v-row>
          <v-col cols="12" md="6" v-if="$route.meta.type === 'tenant'">
            <v-select
              :items="companyTypes.items"
              item-value="id"
              item-title="description"
              label="Tipo"
              v-model="form.company_type"
              :rules="[validationRules.required]"
              :disabled="disabled"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Razão Social"
              v-model="form.razao_social"
              :rules="[validationRules.required]"
              :disabled="disabled"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Nome Fantasia"
              v-model="form.nome_fantasia"
              :disabled="disabled"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="CNPJ"
              v-model="form.cnpj"
              :rules="[validationRules.required, validationRules.cnpj]"
              v-maska="'##.###.###/####-##'"
              :disabled="disabled || !canEditCnpj"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Telefone"
              type="tel"
              v-model="form.phone"
              v-maska="phoneMask"
              :disabled="disabled"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Inscrição Estadual (opcional)"
              v-model="form.state_inscription"
              :rules="[
                validationRules.minLength(2),
                validationRules.maxLength(14),
              ]"
              v-maska="'##############'"
              :disabled="disabled"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Inscrição Municipal (opcional)"
              v-model="form.municipal_inscription"
              :rules="[
                validationRules.minLength(2),
                validationRules.maxLength(14),
              ]"
              v-maska="'###########'"
              :disabled="disabled"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useCompanyTypesQuery } from "@/queries/modules/company_types";
import { validationRules } from "@/utils/validation";

const props = defineProps({
  form: {
    type: Object,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  canEditCnpj: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const emit = defineEmits(["errors"]);

const route = useRoute();

const formRef = ref(null);
const formValid = ref(false);

// TanStack Query for company types
const companyTypesQuery = useCompanyTypesQuery();
const companyTypes = computed(() => ({
  items: (companyTypesQuery.data.value || []).filter((i) => i.id !== "retail"),
  loading: companyTypesQuery.isLoading.value,
}));

const isHeadOffice = computed(() => {
  return /\d{2}\.\d{3}\.\d{3}\/0001-\d{2}$/.test(props.form.cnpj);
});

const phoneMask = computed(() => {
  if (props.form.phone.length <= 14) {
    return "(##) ####-####";
  } else {
    return "(##) #####-####";
  }
});

const emitValidity = (valid) => {
  emit("errors", !valid);
};

const validate = async () => {
  const { valid } = await formRef.value.validate();
  emit("errors", !valid);
  return valid;
};

defineExpose({ validate });
</script>
